export default __webpack_public_path__ + "static/media/eth.cfaf4f5a.svg";